import React, { useState } from "react";
import FaiTypography from "MuiComponents/FaiTypography";
import theme from "assets/theme";
import dataTableData from "./data/dataTableData";
import { Box, Card } from "@mui/material";
import DataList from "screens/Catalog/Inventory/component/DataList";
import OrderDetails from "./component/OrderDetails";

function Tickets({type= "ongoing"}) {
	const { typography } = theme;
	const [orderData, setOrderDetails] = useState();

	  if(orderData){
	    return <OrderDetails {...{orderData, setOrderDetails}} />
	  }

	return (
		<Card className="my-3 p-3 md:p-5">
			<FaiTypography
				variant={"h4"}
				fontWeight={typography.fontWeightMedium}
				mb={"21px"}
			>
				Tickets
			</FaiTypography>
			{/* <Box className="flex flex-col md:flex-row justify-between items-center my-4 w-full gap-3">
				<SearchInput placeholder="Search By Order ID" />
			</Box> */}
			<Box sx={{ mt: 2 }}>
				<DataList data={dataTableData} onRowClick={setOrderDetails} />
			</Box>
		</Card>
	);
}

export default Tickets;
